module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-3-nad_600px_width-0_1.7cb33433.png";